// extracted by mini-css-extract-plugin
export default {"bigImageAd":"index_bigImageAd_Tje5m","bigImageAdPic":"index_bigImageAdPic_wSiNM"};